import { jsx as _jsx } from "react/jsx-runtime";
import { buildContext } from './buildContext';
export const [useGuidaNavigation, NavigationContextProvider] = buildContext();
export const NavigationProvider = ({ children, plannerNavigationCallback, landingPageNavigationCallback }) => {
    return (_jsx(NavigationContextProvider, { value: {
            goToPlanner: plannerNavigationCallback,
            goToLandingPage: landingPageNavigationCallback
        }, children: children }));
};
//# sourceMappingURL=navigation.js.map